export default ({ request }) => ({
  rptCostAllDetailListApi(data = {}) {
    return request({
      url: '/financial/rpt/cost/all/detail/list',
      method: 'POST',
      data,
    })
  },
})
